<template>
  <div>
    <v-dialog v-model="addSignDialog" max-width="450">
      <v-card style="border-radius: 1em">
        <v-card-title>
          <v-spacer></v-spacer>
          <span class="w-700 font-18 text-333333">ตั้งค่าลายเซ็น</span>
          <v-spacer></v-spacer>
          <v-icon @click="close()" color="#00a99d">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="tab">
            <v-tabs-slider color="#00a99d"></v-tabs-slider>
            <v-tab
              href="#sign"
              :style="tab === 'sign' ? 'color: #00a99d' : 'color: #CCCCCC'"
              >วาดลายเซ็น</v-tab
            >
            <v-tab
              href="#upload"
              :style="tab === 'upload' ? 'color: #00a99d' : 'color: #CCCCCC'"
              >อัปโหลดลายเซ็น</v-tab
            >
          </v-tabs>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <!-- วาดลายเซ็น -->
            <v-tab-item value="sign">
              <VueSignaturePad
                ref="signaturePad"
                class="signPad"
                height="200px"
                :options="{
                  onBegin: () => {
                    $refs.signaturePad.resizeCanvas();
                  },
                  onEnd,
                }"
              />
            </v-tab-item>
            <!-- อัปโหลดลายเซ็น -->
            <v-tab-item value="upload">
              <center>
                <v-img
                  v-if="image"
                  :src="imgBase64"
                  @click="inputFile()"
                  max-width="280"
                  height="auto"
                  style="cursor: pointer"
                />
                <v-img
                  v-else
                  src="@/assets/img/profile/upload-signature.svg"
                  @click="inputFile()"
                  style="cursor: pointer"
                />
                <v-file-input
                  id="fileInput"
                  accept="image/png"
                  v-model="image"
                  @change="onFileChange"
                  v-show="false"
                />
              </center>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-btn
            @click="clearSign()"
            depressed
            outlined
            color="#00a99d"
            :disabled="!isWrite"
          >
            ล้างค่า
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click="close()"
            depressed
            outlined
            color="#00a99d"
            :disabled="!isWrite"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            @click="saveSign()"
            depressed
            style="color: white"
            color="#00a99d"
            :disabled="!isWrite"
          >
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card style="border-radius: 1em">
        <v-card-title>
          <v-spacer></v-spacer>
          <span class="w-700 font-18 text-333333">ตั้งค่าลายเซ็น</span>
          <v-spacer></v-spacer>
          <v-icon @click="dialogSuccess = false" color="#00a99d"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="mt-5">
          <center>
            <v-img
              width="160"
              src="@/assets/img/profile/success-signature.svg"
            />
          </center>
        </v-card-text>
        <v-card-text v-if="setupFrom == 'fromProfile'" class="text-center">
          <p class="w-600 font-16 text-333333">สำเร็จ</p>
          <span class="font-16 text-333333">
            คุณได้ทำการตั้งค่าลายเซ็นเรียบร้อยแล้ว
          </span>
        </v-card-text>
        <v-card-text v-if="setupFrom == 'fromDigitalCert'" class="text-center">
          <p class="w-600 font-16 text-333333">ตั้งค่าลายเซ็นสำเร็จ</p>
          <span class="font-16 text-333333">
            คุณต้องการดำเนินการต่อหรือไม่
          </span>
          <v-card-actions class="center mt-4">
            <v-btn
              @click="dialogSuccess = false"
              outlined
              color="#00a99d"
              width="120"
              >ยกเลิก</v-btn
            >
            <v-btn @click="continueSign()" dark color="#00a99d" width="120"
              >ดำเนินการต่อ</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "AddSignDialog",
  data() {
    return {
      addSignDialog: false,
      dialogSuccess: false,
      otp: "",
      tab: "sign",
      isWrite: false,
      image: undefined,
      imgBase64: "",
      setupFrom: "",
    };
  },
  watch: {
    tab() {
      this.clearSign();
    },
    // กดนอกไดอะลอคคแล้วเคลียค่า
    // addSignDialog(val) {
    //   if (val == false) {
    //     this.clearSign();
    //   }
    // }
  },
  computed: {},
  methods: {
    ...mapMutations("doctor", ["set_doctor_sign_img"]),
    ...mapActions("doctor", ["add_sign_image", "get_sign_image"]),
    open(val) {
      this.setupFrom = val;
      this.addSignDialog = true;
    },
    close() {
      this.addSignDialog = false;
      this.clearSign();
    },
    clearSign() {
      this.$refs.signaturePad.clearSignature();
      this.image = undefined;
      this.isWrite = false;
    },
    async saveSign() {
      try {
        let payload = {
          sign: "",
        };
        const { data } = this.$refs.signaturePad.saveSignature();
        if (data) {
          payload.sign = data.split(",")[1];
          this.add_sign_image(payload);
        } else if (this.imgBase64) {
          payload.sign = this.imgBase64.split(",")[1];
          this.add_sign_image(payload);
        }
        this.dialogSuccess = true;
        this.close();
      } catch (error) {
        console.log("error:", error);
      }
    },
    onEnd() {
      this.isWrite = true;
    },
    inputFile() {
      document.getElementById("fileInput").click();
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.imgBase64 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {
        return;
      }
      this.createImage(file);
      this.isWrite = true;
    },
    continueSign() {
      this.$emit("signed");
    },
  },
};
</script>

<style scoped>
.signPad {
  /* border: dashed 3px #00a99d; */
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%2300a99dFF' stroke-width='2' stroke-dasharray='10 15' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 1em;
  background-color: #f5f5f5;
}
.v-btn {
  width: 96px;
  border-radius: 0.7em;
}
</style>
